<template>
  <div>
    <div class="top-bar">
      <div class="top-bar-left">
        <router-link to="/"><img src="../../assets/logo-small.png" alt="" /></router-link>
        <span class="menu-text">Adaptive Feed</span>
      </div>
      <div class="top-bar-right">
        <ul class="dropdown menu" data-dropdown-menu>
          <li v-if="isEnabled('feeds')" v-bind:class="{ active: isActive('/feeds/?') }"><router-link to="/feeds">Hírfolyamok</router-link></li>
          <li v-if="isEnabled('analytics')" v-bind:class="{ active: isActive('/analytics/?') }"><router-link to="/analytics">Elemzések</router-link></li>
          <li v-if="isEnabled('insights')" v-bind:class="{ active: isActive('/insights/?') }"><router-link to="/insights">Kimutatás</router-link></li>
          <li v-if="isEnabled('users')" v-bind:class="{ active: isActive('/users/?') }"><router-link to="/users">Felhasználók</router-link></li>
          <li><a v-on:click="logout"><i class="fi-power icon-med"></i></a></li>
        </ul>
      </div>
    </div>
    <div class="page-header" v-if="$breadcrumbs.length">
      <div class="row expanded">
        <div class="small-8 columns">
          <partials-breadcrumbs></partials-breadcrumbs>
        </div>
        <div class="small-4 columns text-right">
          <partials-actions></partials-actions>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global */

import { mapMutations, mapState } from 'vuex'
import * as mutationTypes from '../store/mutation-types'
import PartialsBreadcrumbs from '../partials/Breadcrumbs'
import PartialsActions from '../partials/Actions'
import acl from '../services/acl'
import CONST from '../../constants'

export default {
  name: 'partials-header',
  components: {
    PartialsBreadcrumbs,
    PartialsActions
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    ...mapMutations([mutationTypes.SET_USER]),
    isEnabled: function (menuId) {
      switch (menuId) {
        case 'feeds':
          return acl.hasRole(this.user, CONST.ROLE.ADMIN)
        case 'analytics':
          return acl.hasRole(this.user, CONST.ROLE.ADMIN)
        case 'insights':
          return true
        case 'users':
          return acl.hasRole(this.user, CONST.ROLE.ADMIN)
      }

      return false
    },
    isActive: function (path) {
      return this.$route.path.match(path)
    },
    logout: function () {
      this[mutationTypes.SET_USER](null)
      this.$router.replace('/')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../sass/foundation-import';

  .top-bar {
    border-top: $topbar-border;
    border-bottom: $topbar-border;
    color: #fff;
    padding: 0;
  }

  .top-bar-left {
    padding-left: rem-calc(0);
  }

  .top-bar-right > .menu > li {
    border-left: 1px solid $topbar-border-color;
    &.flat {
      background: transparent;
      border-color: transparent;
    }
    & > a {
      line-height: rem-calc(40);
      font-size: 85%;
      font-weight: bold;
      padding: 0 rem-calc(10);
      color: #fff;
      &:hover {
        background: $top-menuitem-active-background;
      }
    }
    &.active {
      background-color: $top-menuitem-active-background;
      border-bottom: 1px solid $top-menuitem-active-background;

      & > a {
        background: transparent;
        color: $top-menuitem-active-color;
      }

    }
  }

  .menu > li.flat {
    font-size: rem-calc(14);
    margin-top: $top-menuitem-margin-top / 2;
  }

  .menu.vertical {
    @include box-shadow(2px, 2px, 2px, scale-color($body-background, $lightness: -25%), false);

    & > li {
      @include border-radius(0);
      border-bottom: 1px solid $topbar-border-color;
      &:last-child {
        border-bottom: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Header.vue?5b8cde06